import styled from "styled-components";
import { IButtonStyleProps } from "./interfaces";

export const Container = styled.div`
    position: relative;
`;

export const MainButton = styled.div<IButtonStyleProps>`
    margin-top: ${p => p.isLarge ? 80 : 86}px;
    position: relative;
`;

export const TopButtons = styled.div`
    position: absolute;
    top: 0;
    left: -38px;
    display: flex;
    transform-origin: bottom center;
    transform: scale(0.5);
    opacity: 0;
    transition: 200ms;
    pointer-events: none;
    &.Visible {
        pointer-events: all;
        opacity: 1;
        transform: scale(1);
    }
`;

export const Button = styled.button<IButtonStyleProps>`
    background-color: white;
    width: ${p => p.isLarge ? 86 : 64}px;
    height: ${p => p.isLarge ? 86 : 64}px;
    margin: 0 ${p => (p.isTop ? 4 : (p.isLarge ? 28 : 42))}px;
    margin-top: ${p => (p.isSide ? 32 : 0)}px;
    transform: translate(${p => p.isAside ? 144 : 0}px, ${p => p.isAside ? 140 : 0}px);
    box-shadow: 0 0 0 3px black inset;
    border-radius: ${p => p.isLarge ? 43 : 32}px;
    font-size: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: ${p => p.isAside ? "absolute" : "relative"};
    cursor: pointer;
    user-select: none;
    border: none;
    outline: none;
    font-weight: 600;
    transition: transform 300ms, background-color 300ms, color 300ms;

    &:active {
        transform: translate(${p => p.isAside ? 144 : 0}px, ${p => p.isAside ? 140 : 0}px) scale(1.1);
        background-color: ${p => p.theme.c.active};
        color: white;
    }

    &.Small {
        font-size: 22px;
    }
`;

const Handle = styled.div`
    height: 80px;
    width: 3px;
    background-color: black;
    position: absolute;
    bottom: -28px;
    left: 108px;
    transform-origin: bottom center;
    z-index: -1;
`;

export const Handle1 = styled(Handle)`
    transform: rotate(-50deg);
`;

export const Handle2 = styled(Handle)``;

export const Handle3 = styled(Handle)`
    transform: rotate(50deg);
`;

export const Handle4 = styled(Handle)`
    transform: rotate(133deg) translate(-10px, 13px);
`;

export const Sup = styled.div`
    position: absolute;
    top: 2px;
`;

export const Sub = styled.div`
    position: absolute;
    top: 26px;
`;

export const Sub1 = styled.div`
    position: relative;
    top: -3px;
`;

export const Sub2 = styled.div`
    position: relative;
    top: 5px;
    margin-left: 1px;
`;
